import { Component, Input, OnInit, OnChanges } from '@angular/core';
import { Agent } from 'core/models/agent';
import { AgentsCacheService } from 'core/services/agents-cache.service';

@Component({
  selector: 'lms-agent-chip',
  templateUrl: './agent-chip.component.html',
  styleUrls: ['./agent-chip.component.scss']
})
export class AgentChipComponent implements OnInit, OnChanges {
  @Input() agentId: string;
  agent: Agent;

  constructor(public agentsCache: AgentsCacheService) {}

  ngOnInit() {}

  ngOnChanges() {
    this.agent = this.agentsCache.getAgent(this.agentId);
  }
}
